import {
  CREATE_EVENT_REQUEST,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  RESET_EVENTS_STATE,
} from "../../../types/event";

const initialState = {
  loading: false,
  data: null,
  message: "",
  error: "",
  success: false,
};

const createEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case CREATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        message: "Event created successfully",
        success: true,
      };
      case CREATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.error || "Failed to create event",
        success: false,
      };
    case RESET_EVENTS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default createEventReducer;
